import React, { FC, useCallback } from 'react';
import { Switch, Route, Router } from 'Utils/router'; //eslint-disable-line
import { StepContainer } from 'Containers/stepContainer';//eslint-disable-line
import TourInitializer from 'HOC/TourInitializer';
import YouVisitAnalytics from 'HOC/YouVisitAnalytics';

interface Props {
  tour: any; //eslint-disable-line
}

const Routes: FC<Props> = (props: Props) => {
  const stepContainerCallBack = useCallback(() => <StepContainer />, [props]);
  return (
    <Router>
      <TourInitializer>
        <YouVisitAnalytics>
          <Switch>
            <Route exact path="/" render={stepContainerCallBack} />
            <Route path="/:instId/:locId" render={stepContainerCallBack} />
            <Route>404: Page not found</Route>
          </Switch>
        </YouVisitAnalytics>
      </TourInitializer>
    </Router>
  );
};

export default Routes;
try {
    // @ts-ignore
    routes.displayName = "routes";
    // @ts-ignore
    routes.__docgenInfo = { "description": "", "displayName": "routes", "props": { "tour": { "defaultValue": null, "description": "", "name": "tour", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/routes.tsx#routes"] = { docgenInfo: routes.__docgenInfo, name: "routes", path: "src/routes/routes.tsx#routes" };
}
catch (__react_docgen_typescript_loader_error) { }